import(/* webpackMode: "eager", webpackExports: ["Badge","badgeVariants"] */ "/vercel/path0/gondola-web-app/components/ui/badge/Badge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/client/link.js");
